/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFrameSizeMinIcon16Regular = forwardRef('UiFrameSizeMinIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10 1.25a.75.75 0 0 1 .75.75v2.5c0 .414.336.75.75.75H14a.75.75 0 0 1 0 1.5h-2.5A2.25 2.25 0 0 1 9.25 4.5V2a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M2 9.25a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 1 .75.75V14a.75.75 0 0 0 1.5 0v-2.5A2.25 2.25 0 0 0 4.5 9.25H2Z" }),
        React.createElement("path", { d: "M11.5 9.25a2.25 2.25 0 0 0-2.25 2.25V14a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 1 .75-.75H14a.75.75 0 0 0 0-1.5h-2.5Z" }),
        React.createElement("path", { d: "M6.75 2a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 1-.75.75H2a.75.75 0 0 0 0 1.5h2.5A2.25 2.25 0 0 0 6.75 4.5V2Z" })));
});
